var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 87 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2302 55.22L58.75 58.39L39.4302 69.57L33.5801 59.52L48.4001 50.94L30.4302 40.73L22.1301 36L10.3601 29.3L10.6602 76.7L2.36011 71.98L2 15.11L22.0701 26.52L30.3701 31.25L48.3401 41.46L37.6301 23.35L33.3101 16.03L37.29 13.71L39.1702 12.63L41.0701 15.86L49.4202 30.06L58.9502 46.25L64.2302 55.22Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3401 41.46L30.3701 31.25L22.0701 26.52L2 15.11L21.9402 4.97998L37.29 13.71L33.3101 16.03L37.6301 23.35L48.3401 41.46Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4294 40.73L30.5994 66.5801L10.6594 76.7001L10.3594 29.3L22.1294 36.0001L30.4294 40.73Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1599 45.1L64.23 55.22L58.95 46.25L49.4199 30.06L41.0698 15.86L39.1699 12.63L59.0999 2.51001L84.1599 45.1Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1597 45.1L59.3596 59.44L39.4297 69.57L58.7495 58.39L64.2297 55.22L84.1597 45.1Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.658b2dc3962a9f7a4090d8e5509e765e.svg";
export { ForwardRef as ReactComponent };